import { ReactNode } from 'react';

import { HomeIcon } from './icons';

export type NavLink = {
  label: string;
  to?: string;
  href?: string;
  icon?: ReactNode;
  badge?: number;
};

export type NavGroup = {
  label: string;
  children: NavLink[];
};

export type NavEntry = NavLink | NavGroup;

export const isNavGroup = (entry: NavEntry): entry is NavGroup => 'children' in entry;

export type MenuContext = {
  isRede: boolean;
  isManager: boolean;
  canAccessCatalog: boolean;
  showCatalog: boolean;
  rewardsLabel: string;
  canRenouncePreferences: boolean;
};

export function buildMenuEntries(ctx: MenuContext): NavEntry[] {
  const regulamento = [
    { label: 'Regras', to: '/regulamento' },
    { label: 'Dúvidas frequentes', to: '/ajuda' },
    ctx.canRenouncePreferences && { label: 'Minhas preferências', to: '/minhas-preferencias' },
    { label: 'Nosso manifesto', to: '/manifesto' },
  ].filter(Boolean) as NavLink[];

  return [
    { label: 'Página inicial', to: '/', icon: <HomeIcon /> },
    { label: 'Destaques', to: '/destaques' },
    ctx.showCatalog && { label: ctx.rewardsLabel, to: ctx.isRede ? '/loja' : '/catalogo-de-experiencias' },
    ctx.canAccessCatalog && { label: 'Catálogo de Experiências', to: '/catalogo-de-experiencias-list' },
    { label: 'Feed Joga Junto', to: '/rede-joga-junto' },
    ctx.isManager && !ctx.isRede && { label: 'Minha Equipe', to: '/minha-equipe' },
    { label: 'Regulamento', children: regulamento },
  ].filter(Boolean) as NavEntry[];
}
